// ==========================================
// STAFFING DOMAIN MOCK DATA
// FST.2–FST.6 — Manager + Director views
// Benchmarks from data_source_inventory.xlsx (MGMA, BLS)
// ==========================================

// ==========================================
// FST.2 — Daily Staffing Dashboard
// ==========================================
export const mockDailyStaffingDashboard = {
  'unit-4w': {
    lastRefresh: '2026-03-31T06:45:00Z',
    coverageStatus: {
      scheduled: 16, required: 18, percentage: 89, target: 95,
      status: 'watch', trend: -3, trendLabel: 'vs last week',
    },
    openShifts: {
      today: 3, next7Days: 8,
      byRole: { RN: 2, MA: 1, 'Front Desk': 0 },
      criticalGaps: [{ role: 'Triage RN', department: 'Primary Care A', shift: 'Day' }],
    },
    otExposure: {
      currentHours: 42, thresholdHours: 40, regularHours: 400,
      projectedWeeklyCost: 6300, budgetThreshold: 5000,
      highestDept: 'Primary Care A', status: 'critical',
    },
    staffingVsVolume: {
      ratio: 4.2, target: 3.8, trend: 'up', trendLabel: '+0.4 vs last week',
      status: 'watch',
    },
    departments: [
      { id: 'dept-pca', name: 'Primary Care A', coverage: 72, required: 8, scheduled: 6, actual: 5, openShifts: 2, otHours: 18, status: 'critical' },
      { id: 'dept-pcb', name: 'Primary Care B', coverage: 85, required: 6, scheduled: 5, actual: 5, openShifts: 1, otHours: 8, status: 'watch' },
      { id: 'dept-onc', name: 'Oncology', coverage: 90, required: 5, scheduled: 5, actual: 4, openShifts: 0, otHours: 12, status: 'watch' },
      { id: 'dept-uc', name: 'Urgent Care', coverage: 100, required: 4, scheduled: 4, actual: 4, openShifts: 0, otHours: 2, status: 'on-track' },
      { id: 'dept-admin', name: 'Admin / Front Desk', coverage: 100, required: 3, scheduled: 3, actual: 3, openShifts: 0, otHours: 2, status: 'on-track' },
    ],
    roleQueueSummary: { total: 24, assigned: 18, pending: 2, unassigned: 4 },
  },
  all: {
    lastRefresh: '2026-03-31T06:45:00Z',
    coverageStatus: { scheduled: 48, required: 52, percentage: 92, target: 95, status: 'watch', trend: -1, trendLabel: 'vs last week' },
    openShifts: { today: 5, next7Days: 14, byRole: { RN: 3, MA: 1, 'Front Desk': 1 }, criticalGaps: [] },
    otExposure: { currentHours: 96, thresholdHours: 100, regularHours: 1000, projectedWeeklyCost: 14400, budgetThreshold: 15000, highestDept: 'Primary Care A', status: 'watch' },
    staffingVsVolume: { ratio: 3.9, target: 3.8, trend: 'stable', trendLabel: '0.0 vs last week', status: 'on-track' },
    departments: [],
    roleQueueSummary: { total: 72, assigned: 60, pending: 4, unassigned: 8 },
  },
};

// ==========================================
// FST.3 — Role Assignment Queue
// ==========================================
export const mockRoleAssignmentQueue = {
  'unit-4w': {
    date: '2026-03-31',
    shiftOptions: ['Day (7a-7p)', 'Evening (3p-11p)', 'Night (11p-7a)'],
    roles: [
      { id: 'ra-001', roleName: 'Charge Nurse', department: 'Primary Care A', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', defaultStaffId: 'staff-101', defaultStaffName: 'Maria Lopez', assignedStaffId: 'staff-101', assignedStaffName: 'Maria Lopez', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:30:00Z', callOut: false },
      { id: 'ra-002', roleName: 'Triage RN', department: 'Primary Care A', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', defaultStaffId: 'staff-102', defaultStaffName: 'James Park', assignedStaffId: null, assignedStaffName: null, acknowledgment: 'unassigned', acknowledgedAt: null, callOut: true },
      { id: 'ra-003', roleName: 'Rooming RN', department: 'Primary Care A', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: 'RN License', defaultStaffId: 'staff-103', defaultStaffName: 'Sarah Kim', assignedStaffId: 'staff-103', assignedStaffName: 'Sarah Kim', acknowledgment: 'pending', acknowledgedAt: null, callOut: false },
      { id: 'ra-004', roleName: 'Medical Assistant', department: 'Primary Care A', category: 'Clinical — Support', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, defaultStaffId: 'staff-104', defaultStaffName: 'Emily Tran', assignedStaffId: 'staff-104', assignedStaffName: 'Emily Tran', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:28:00Z', callOut: false },
      { id: 'ra-005', roleName: 'Charge Nurse', department: 'Primary Care B', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', defaultStaffId: 'staff-105', defaultStaffName: 'David Chen', assignedStaffId: 'staff-105', assignedStaffName: 'David Chen', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:25:00Z', callOut: false },
      { id: 'ra-006', roleName: 'Floor RN', department: 'Primary Care B', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: 'RN License', defaultStaffId: 'staff-106', defaultStaffName: 'Amanda Foster', assignedStaffId: null, assignedStaffName: null, acknowledgment: 'unassigned', acknowledgedAt: null, callOut: false },
      { id: 'ra-007', roleName: 'Check-In', department: 'Admin / Front Desk', category: 'Administrative — Front Desk', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, defaultStaffId: 'staff-107', defaultStaffName: 'Rosa Martinez', assignedStaffId: 'staff-107', assignedStaffName: 'Rosa Martinez', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:20:00Z', callOut: false },
      { id: 'ra-008', roleName: 'Infusion RN', department: 'Oncology', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License + OCN', defaultStaffId: 'staff-108', defaultStaffName: 'Patricia Gomez', assignedStaffId: 'staff-108', assignedStaffName: 'Patricia Gomez', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:32:00Z', callOut: false },
      { id: 'ra-009', roleName: 'Care Coordinator', department: 'Oncology', category: 'Administrative — Operations', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, defaultStaffId: 'staff-109', defaultStaffName: 'Kevin Wright', assignedStaffId: 'staff-109', assignedStaffName: 'Kevin Wright', acknowledgment: 'pending', acknowledgedAt: null, callOut: false },
      { id: 'ra-010', roleName: 'Triage RN', department: 'Urgent Care', category: 'Clinical — Nursing', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', defaultStaffId: 'staff-110', defaultStaffName: 'Lisa Nguyen', assignedStaffId: 'staff-110', assignedStaffName: 'Lisa Nguyen', acknowledgment: 'confirmed', acknowledgedAt: '2026-03-31T06:22:00Z', callOut: false },
    ],
    roleLibrary: [
      { id: 'rl-001', name: 'Charge Nurse', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: true, isCustom: false },
      { id: 'rl-002', name: 'Triage RN', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: true, isCustom: false },
      { id: 'rl-003', name: 'Rooming RN', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: false, isCustom: false },
      { id: 'rl-004', name: 'Floor RN', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: false, isCustom: false },
      { id: 'rl-005', name: 'Infusion RN', category: 'Clinical — Nursing', credentialRequired: 'RN License + OCN', isCritical: true, isCustom: false },
      { id: 'rl-006', name: 'Float RN', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: false, isCustom: false },
      { id: 'rl-007', name: 'Care Coordinator RN', category: 'Clinical — Nursing', credentialRequired: 'RN License', isCritical: false, isCustom: false },
      { id: 'rl-008', name: 'Oncology Nurse Navigator', category: 'Clinical — Nursing', credentialRequired: 'RN License + OCN', isCritical: false, isCustom: true },
      { id: 'rl-009', name: 'Medical Assistant (Rooming)', category: 'Clinical — Support', credentialRequired: null, isCritical: false, isCustom: false },
      { id: 'rl-010', name: 'Medical Assistant (Front)', category: 'Clinical — Support', credentialRequired: null, isCritical: false, isCustom: false },
      { id: 'rl-011', name: 'Check-In', category: 'Administrative — Front Desk', credentialRequired: null, isCritical: false, isCustom: false },
      { id: 'rl-012', name: 'Check-Out', category: 'Administrative — Front Desk', credentialRequired: null, isCritical: false, isCustom: false },
      { id: 'rl-013', name: 'Care Coordinator', category: 'Administrative — Operations', credentialRequired: null, isCritical: false, isCustom: false },
      { id: 'rl-014', name: 'Authorization Coordinator', category: 'Administrative — Operations', credentialRequired: null, isCritical: false, isCustom: false },
    ],
    availableStaff: [
      { id: 'staff-101', name: 'Maria Lopez', role: 'RN', department: 'Primary Care A', credentials: ['RN License'] },
      { id: 'staff-103', name: 'Sarah Kim', role: 'RN', department: 'Float Pool', credentials: ['RN License'] },
      { id: 'staff-111', name: 'Karen Lee', role: 'RN', department: 'Float Pool', credentials: ['RN License'] },
      { id: 'staff-104', name: 'Emily Tran', role: 'MA', department: 'Primary Care A', credentials: [] },
      { id: 'staff-105', name: 'David Chen', role: 'RN', department: 'Primary Care B', credentials: ['RN License'] },
      { id: 'staff-106', name: 'Amanda Foster', role: 'RN', department: 'Primary Care B', credentials: ['RN License'] },
      { id: 'staff-107', name: 'Rosa Martinez', role: 'Front Desk', department: 'Admin', credentials: [] },
      { id: 'staff-108', name: 'Patricia Gomez', role: 'RN', department: 'Oncology', credentials: ['RN License', 'OCN'] },
      { id: 'staff-109', name: 'Kevin Wright', role: 'Coordinator', department: 'Oncology', credentials: [] },
      { id: 'staff-110', name: 'Lisa Nguyen', role: 'RN', department: 'Urgent Care', credentials: ['RN License'] },
      { id: 'staff-112', name: 'Tom Bradley', role: 'RN', department: 'Primary Care A', credentials: ['RN License'] },
    ],
  },
};

// ==========================================
// FST.4 — Credential & Compliance Tracking
// ==========================================
const today = new Date('2026-03-31');
function daysUntil(dateStr) {
  return Math.round((new Date(dateStr) - today) / 86400000);
}
function credStatus(dateStr) {
  if (!dateStr) return 'no-expiration';
  const d = daysUntil(dateStr);
  if (d < 0) return 'expired';
  if (d <= 30) return 'expiring-soon';
  if (d <= 90) return 'upcoming';
  return 'current';
}

const rawCredentials = [
  { id: 'cred-001', staffId: 'staff-101', staffName: 'Maria Lopez', staffType: 'Provider', role: 'RN', department: 'Primary Care A', type: 'RN License', state: 'NY', expirationDate: '2026-04-15', lastVerified: '2026-01-10', notes: '' },
  { id: 'cred-002', staffId: 'staff-101', staffName: 'Maria Lopez', staffType: 'Provider', role: 'RN', department: 'Primary Care A', type: 'BLS', state: null, expirationDate: '2027-06-01', lastVerified: '2025-06-01', notes: '' },
  { id: 'cred-003', staffId: 'staff-102', staffName: 'James Park', staffType: 'Provider', role: 'RN', department: 'Primary Care A', type: 'BLS', state: null, expirationDate: '2026-03-28', lastVerified: '2024-03-28', notes: 'Renewal submitted' },
  { id: 'cred-004', staffId: 'staff-102', staffName: 'James Park', staffType: 'Provider', role: 'RN', department: 'Primary Care A', type: 'RN License', state: 'NY', expirationDate: '2026-08-15', lastVerified: '2024-08-15', notes: '' },
  { id: 'cred-005', staffId: 'staff-105', staffName: 'David Chen', staffType: 'Provider', role: 'RN', department: 'Primary Care B', type: 'RN License', state: 'NY', expirationDate: '2026-05-20', lastVerified: '2024-05-20', notes: '' },
  { id: 'cred-006', staffId: 'staff-105', staffName: 'David Chen', staffType: 'Provider', role: 'RN', department: 'Primary Care B', type: 'ACLS', state: null, expirationDate: '2026-04-10', lastVerified: '2024-04-10', notes: '' },
  { id: 'cred-007', staffId: 'staff-108', staffName: 'Patricia Gomez', staffType: 'Provider', role: 'RN', department: 'Oncology', type: 'RN License', state: 'NY', expirationDate: '2027-01-15', lastVerified: '2025-01-15', notes: '' },
  { id: 'cred-008', staffId: 'staff-108', staffName: 'Patricia Gomez', staffType: 'Provider', role: 'RN', department: 'Oncology', type: 'OCN', state: null, expirationDate: '2027-09-01', lastVerified: '2025-09-01', notes: '' },
  { id: 'cred-009', staffId: 'staff-110', staffName: 'Lisa Nguyen', staffType: 'Provider', role: 'RN', department: 'Urgent Care', type: 'RN License', state: 'NY', expirationDate: '2026-03-15', lastVerified: '2024-03-15', notes: 'EXPIRED — renewal pending' },
  { id: 'cred-010', staffId: 'staff-110', staffName: 'Lisa Nguyen', staffType: 'Provider', role: 'RN', department: 'Urgent Care', type: 'BLS', state: null, expirationDate: '2026-04-01', lastVerified: '2024-04-01', notes: '' },
  { id: 'cred-011', staffId: 'staff-104', staffName: 'Emily Tran', staffType: 'Nurse/Clinical Staff', role: 'MA', department: 'Primary Care A', type: 'HIPAA Training', state: null, expirationDate: '2026-06-30', lastVerified: '2025-06-30', notes: '' },
  { id: 'cred-012', staffId: 'staff-104', staffName: 'Emily Tran', staffType: 'Nurse/Clinical Staff', role: 'MA', department: 'Primary Care A', type: 'Fire Safety', state: null, expirationDate: '2026-04-28', lastVerified: '2025-04-28', notes: '' },
  { id: 'cred-013', staffId: 'staff-103', staffName: 'Sarah Kim', staffType: 'Provider', role: 'RN', department: 'Float Pool', type: 'RN License', state: 'NY', expirationDate: '2027-02-28', lastVerified: '2025-02-28', notes: '' },
  { id: 'cred-014', staffId: 'staff-103', staffName: 'Sarah Kim', staffType: 'Provider', role: 'RN', department: 'Float Pool', type: 'BLS', state: null, expirationDate: '2026-04-20', lastVerified: '2024-04-20', notes: '' },
  { id: 'cred-015', staffId: 'staff-106', staffName: 'Amanda Foster', staffType: 'Provider', role: 'RN', department: 'Primary Care B', type: 'RN License', state: 'NY', expirationDate: '2026-11-30', lastVerified: '2024-11-30', notes: '' },
  { id: 'cred-016', staffId: 'staff-107', staffName: 'Rosa Martinez', staffType: 'Nurse/Clinical Staff', role: 'Front Desk', department: 'Admin', type: 'HIPAA Training', state: null, expirationDate: '2026-09-15', lastVerified: '2025-09-15', notes: '' },
];

const credentials = rawCredentials.map((c) => ({
  ...c,
  daysUntilExpiration: c.expirationDate ? daysUntil(c.expirationDate) : null,
  status: credStatus(c.expirationDate),
}));

const expired = credentials.filter((c) => c.status === 'expired');
const expiring30 = credentials.filter((c) => c.status === 'expiring-soon');
const expiring60 = credentials.filter((c) => c.status === 'upcoming');

export const mockCredentialData = {
  'unit-4w': {
    lastRefresh: '2026-03-31T06:45:00Z',
    summary: {
      total: credentials.length,
      current: credentials.filter((c) => c.status === 'current').length,
      expired: expired.length,
      expiring30d: expiring30.length,
      expiring60d: expiring60.length,
    },
    credentials,
    reviewQueue: [
      ...expired.map((c) => ({ ...c, action: 'renew', urgency: 'critical' })),
      ...expiring30.map((c) => ({ ...c, action: 'renew', urgency: 'warning' })),
    ],
    auditLog: [
      { id: 'audit-001', action: 'upload', user: 'Sarah Chen', timestamp: '2026-03-29T10:00:00Z', details: 'Bulk upload — 16 credential records' },
      { id: 'audit-002', action: 'status_change', credentialId: 'cred-009', user: 'Sarah Chen', timestamp: '2026-03-29T10:15:00Z', details: 'Lisa Nguyen RN License marked as expired' },
      { id: 'audit-003', action: 'notification_sent', credentialId: 'cred-003', user: 'Sarah Chen', timestamp: '2026-03-28T14:00:00Z', details: 'Renewal reminder sent to James Park for BLS' },
      { id: 'audit-004', action: 'reviewed', credentialId: 'cred-007', user: 'Sarah Chen', timestamp: '2026-03-27T09:00:00Z', details: 'Patricia Gomez RN License verified current' },
    ],
  },
  all: {
    summary: { total: credentials.length, current: credentials.filter((c) => c.status === 'current').length, expired: expired.length, expiring30d: expiring30.length, expiring60d: expiring60.length },
    credentials,
    reviewQueue: [],
    auditLog: [],
  },
};

// ==========================================
// FST.5 — Absence Pattern Intelligence
// ==========================================
export const mockAbsencePatterns = {
  'unit-4w': {
    lastRefresh: '2026-03-31T06:45:00Z',
    hasMinimumHistory: true,
    weeksCovered: 12,
    summary: {
      overallRate: 0.062,
      rolling30dRate: 0.058,
      absenceDrivenOTPct: 0.34,
      threshold: 0.08,
    },
    byDepartment: [
      { department: 'Primary Care A', rate: 0.072, count: 14, flag: true, flagReason: '20% above practice average' },
      { department: 'Primary Care B', rate: 0.051, count: 8, flag: false, flagReason: null },
      { department: 'Oncology', rate: 0.045, count: 5, flag: false, flagReason: null },
      { department: 'Urgent Care', rate: 0.041, count: 4, flag: false, flagReason: null },
      { department: 'Admin / Front Desk', rate: 0.032, count: 3, flag: false, flagReason: null },
    ],
    byRole: [
      { role: 'RN', rate: 0.068, count: 18, flag: true, flagReason: 'Trending up 3 consecutive weeks' },
      { role: 'MA', rate: 0.052, count: 6, flag: false, flagReason: null },
      { role: 'Front Desk', rate: 0.041, count: 4, flag: false, flagReason: null },
      { role: 'Coordinator', rate: 0.028, count: 2, flag: false, flagReason: null },
    ],
    byDayOfWeek: [
      { day: 'Mon', rate: 0.092 }, { day: 'Tue', rate: 0.055 },
      { day: 'Wed', rate: 0.048 }, { day: 'Thu', rate: 0.051 },
      { day: 'Fri', rate: 0.078 }, { day: 'Sat', rate: 0.032 }, { day: 'Sun', rate: 0.029 },
    ],
    byType: [
      { type: 'Unplanned Call-Out', rate: 0.032, count: 16 },
      { type: 'Planned Leave', rate: 0.018, count: 9 },
      { type: 'FMLA', rate: 0.008, count: 4 },
      { type: 'No-Call/No-Show', rate: 0.004, count: 2 },
    ],
    trend12Week: [
      { week: 'W1', rate: 0.058 }, { week: 'W2', rate: 0.055 }, { week: 'W3', rate: 0.062 },
      { week: 'W4', rate: 0.059 }, { week: 'W5', rate: 0.061 }, { week: 'W6', rate: 0.065 },
      { week: 'W7', rate: 0.058 }, { week: 'W8', rate: 0.063 }, { week: 'W9', rate: 0.068 },
      { week: 'W10', rate: 0.062 }, { week: 'W11', rate: 0.058 }, { week: 'W12', rate: 0.062 },
    ],
    patternFlags: [
      { id: 'flag-001', description: 'Monday call-out rate 48% above average', department: 'Primary Care A', severity: 'critical' },
      { id: 'flag-002', description: 'RN absence rate trending up 3 consecutive weeks', department: 'All', severity: 'watch' },
      { id: 'flag-003', description: 'Friday call-out rate 26% above average', department: 'All', severity: 'watch' },
    ],
  },
  all: {
    hasMinimumHistory: true,
    weeksCovered: 12,
    summary: { overallRate: 0.055, rolling30dRate: 0.052, absenceDrivenOTPct: 0.28, threshold: 0.08 },
    byDepartment: [], byRole: [], byDayOfWeek: [], byType: [],
    trend12Week: [
      { week: 'W1', rate: 0.052 }, { week: 'W2', rate: 0.050 }, { week: 'W3', rate: 0.055 },
      { week: 'W4', rate: 0.053 }, { week: 'W5', rate: 0.054 }, { week: 'W6', rate: 0.058 },
      { week: 'W7', rate: 0.052 }, { week: 'W8', rate: 0.056 }, { week: 'W9', rate: 0.059 },
      { week: 'W10', rate: 0.055 }, { week: 'W11', rate: 0.052 }, { week: 'W12', rate: 0.055 },
    ],
    patternFlags: [],
  },
};

// ==========================================
// FST.6 — FTE Budget vs. Actual
// ==========================================
export const mockFTEBudget = {
  'unit-4w': {
    lastRefresh: '2026-03-31T06:45:00Z',
    summary: {
      totalBudgetedFTE: 22.0, totalActualFTE: 20.5, variance: -1.5, variancePct: -6.8,
      vacancies: 2, agencyFTE: 1.5, agencyCostPremium: 4200, agencyFlag: true,
      projectedEndOfPeriod: { budgeted: 22.0, projected: 21.0, variance: -1.0, variancePct: -4.5 },
    },
    byDepartment: [
      { department: 'Primary Care A', budgeted: 10.0, actual: 9.0, variance: -1.0, variancePct: -10.0, vacancies: 1, agency: 0.5 },
      { department: 'Primary Care B', budgeted: 8.0, actual: 7.5, variance: -0.5, variancePct: -6.3, vacancies: 1, agency: 0.5 },
      { department: 'Oncology', budgeted: 5.0, actual: 5.0, variance: 0, variancePct: 0, vacancies: 0, agency: 0.5 },
      { department: 'Urgent Care', budgeted: 4.0, actual: 4.0, variance: 0, variancePct: 0, vacancies: 0, agency: 0 },
      { department: 'Admin / Front Desk', budgeted: 3.0, actual: 3.0, variance: 0, variancePct: 0, vacancies: 0, agency: 0 },
    ],
    byRole: [
      { role: 'Physician', budgeted: 4.0, actual: 3.5, variance: -0.5, variancePct: -12.5, hourlyRate: '$250–400' },
      { role: 'PA / NP', budgeted: 3.0, actual: 3.0, variance: 0, variancePct: 0, hourlyRate: '$90–140' },
      { role: 'RN', budgeted: 8.0, actual: 7.0, variance: -1.0, variancePct: -12.5, hourlyRate: '$60–90' },
      { role: 'MA', budgeted: 4.0, actual: 4.0, variance: 0, variancePct: 0, hourlyRate: '$35–55' },
      { role: 'Front Desk / Admin', budgeted: 3.0, actual: 3.0, variance: 0, variancePct: 0, hourlyRate: '$35–55' },
    ],
    trend12Week: [
      { week: 'W1', budgeted: 22.0, actual: 20.0, agency: 1.0 },
      { week: 'W2', budgeted: 22.0, actual: 20.5, agency: 1.0 },
      { week: 'W3', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W4', budgeted: 22.0, actual: 20.0, agency: 1.5 },
      { week: 'W5', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W6', budgeted: 22.0, actual: 21.0, agency: 1.0 },
      { week: 'W7', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W8', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W9', budgeted: 22.0, actual: 20.0, agency: 2.0 },
      { week: 'W10', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W11', budgeted: 22.0, actual: 20.5, agency: 1.5 },
      { week: 'W12', budgeted: 22.0, actual: 20.5, agency: 1.5 },
    ],
  },
  all: {
    summary: { totalBudgetedFTE: 66.0, totalActualFTE: 62.0, variance: -4.0, variancePct: -6.1, vacancies: 5, agencyFTE: 3.5, agencyCostPremium: 9800, agencyFlag: true, projectedEndOfPeriod: { budgeted: 66.0, projected: 63.0, variance: -3.0, variancePct: -4.5 } },
    byDepartment: [],
    byRole: [],
    trend12Week: [],
  },
};

// ==========================================
// DIRECTOR — Cross-site data
// ==========================================
export const mockDirectorStaffingDashboard = {
  'region-primary-care': {
    lastRefresh: '2026-03-31T06:45:00Z',
    sites: [
      { siteId: 'unit-3w', siteName: '3 West', coverage: 78, openShifts: 5, otPct: 15.2, staffRatio: 5.1, credExpired: 3, absenceRate: 7.8, fteVariance: -12.0, status: 'critical' },
      { siteId: 'unit-4w', siteName: '4 West', coverage: 89, openShifts: 3, otPct: 10.5, staffRatio: 4.2, credExpired: 1, absenceRate: 6.2, fteVariance: -6.8, status: 'watch' },
      { siteId: 'unit-5n', siteName: '5 North', coverage: 96, openShifts: 1, otPct: 7.2, staffRatio: 3.6, credExpired: 0, absenceRate: 4.5, fteVariance: -2.1, status: 'on-track' },
      { siteId: 'unit-2e', siteName: '2 East', coverage: 92, openShifts: 2, otPct: 8.8, staffRatio: 3.9, credExpired: 0, absenceRate: 5.1, fteVariance: -3.5, status: 'on-track' },
    ],
    aggregated: { avgCoverage: 89, totalOpenShifts: 11, avgOTPct: 10.4, avgStaffRatio: 4.2, totalCredExpired: 4, avgAbsenceRate: 5.9, avgFTEVariance: -6.1 },
  },
  'mob-cardiology': {
    sites: [
      { siteId: 'unit-card-1', siteName: 'Cardiology Main', coverage: 94, openShifts: 1, otPct: 6.5, staffRatio: 3.5, credExpired: 0, absenceRate: 3.8, fteVariance: -1.5, status: 'on-track' },
      { siteId: 'unit-card-2', siteName: 'Cardiology South', coverage: 88, openShifts: 2, otPct: 9.1, staffRatio: 4.0, credExpired: 1, absenceRate: 5.5, fteVariance: -5.0, status: 'watch' },
    ],
    aggregated: { avgCoverage: 91, totalOpenShifts: 3, avgOTPct: 7.8, avgStaffRatio: 3.8, totalCredExpired: 1, avgAbsenceRate: 4.7, avgFTEVariance: -3.3 },
  },
};

export const mockDirectorRoleAssignments = {
  'region-primary-care': {
    sites: [
      { siteId: 'unit-3w', siteName: '3 West', totalRoles: 20, assigned: 14, pending: 2, unassigned: 4, ackRate: 70, status: 'critical' },
      { siteId: 'unit-4w', siteName: '4 West', totalRoles: 24, assigned: 18, pending: 2, unassigned: 4, ackRate: 75, status: 'watch' },
      { siteId: 'unit-5n', siteName: '5 North', totalRoles: 18, assigned: 17, pending: 1, unassigned: 0, ackRate: 94, status: 'on-track' },
      { siteId: 'unit-2e', siteName: '2 East', totalRoles: 16, assigned: 15, pending: 1, unassigned: 0, ackRate: 94, status: 'on-track' },
    ],
    aggregated: { totalRoles: 78, assigned: 64, pending: 6, unassigned: 8, avgAckRate: 83 },
  },
};

export const mockDirectorCredentials = {
  'region-primary-care': {
    sites: [
      { siteId: 'unit-3w', siteName: '3 West', total: 42, current: 35, expired: 3, expiring30d: 2, expiring60d: 2, complianceRate: 83, status: 'critical' },
      { siteId: 'unit-4w', siteName: '4 West', total: 16, current: 10, expired: 1, expiring30d: 3, expiring60d: 2, complianceRate: 63, status: 'critical' },
      { siteId: 'unit-5n', siteName: '5 North', total: 38, current: 36, expired: 0, expiring30d: 1, expiring60d: 1, complianceRate: 95, status: 'on-track' },
      { siteId: 'unit-2e', siteName: '2 East', total: 30, current: 28, expired: 0, expiring30d: 1, expiring60d: 1, complianceRate: 93, status: 'on-track' },
    ],
    aggregated: { total: 126, current: 109, expired: 4, expiring30d: 7, expiring60d: 6, avgComplianceRate: 84 },
  },
};

export const mockDirectorAbsencePatterns = {
  'region-primary-care': {
    sites: [
      { siteId: 'unit-3w', siteName: '3 West', rate: 7.8, absenceDrivenOTPct: 42, trend: 'up', patternFlags: 2, status: 'critical' },
      { siteId: 'unit-4w', siteName: '4 West', rate: 6.2, absenceDrivenOTPct: 34, trend: 'stable', patternFlags: 3, status: 'watch' },
      { siteId: 'unit-5n', siteName: '5 North', rate: 4.5, absenceDrivenOTPct: 22, trend: 'down', patternFlags: 0, status: 'on-track' },
      { siteId: 'unit-2e', siteName: '2 East', rate: 5.1, absenceDrivenOTPct: 28, trend: 'stable', patternFlags: 1, status: 'on-track' },
    ],
    aggregated: { avgRate: 5.9, avgAbsenceDrivenOTPct: 32, totalPatternFlags: 6 },
  },
};

export const mockDirectorFTEBudget = {
  'region-primary-care': {
    sites: [
      { siteId: 'unit-3w', siteName: '3 West', budgeted: 24.0, actual: 21.0, variance: -3.0, variancePct: -12.5, vacancies: 3, agency: 2.0, status: 'critical' },
      { siteId: 'unit-4w', siteName: '4 West', budgeted: 22.0, actual: 20.5, variance: -1.5, variancePct: -6.8, vacancies: 2, agency: 1.5, status: 'watch' },
      { siteId: 'unit-5n', siteName: '5 North', budgeted: 20.0, actual: 19.5, variance: -0.5, variancePct: -2.5, vacancies: 0, agency: 0, status: 'on-track' },
      { siteId: 'unit-2e', siteName: '2 East', budgeted: 18.0, actual: 17.0, variance: -1.0, variancePct: -5.6, vacancies: 1, agency: 0.5, status: 'watch' },
    ],
    aggregated: { budgeted: 84.0, actual: 78.0, variance: -6.0, variancePct: -7.1, vacancies: 6, agency: 4.0 },
  },
};

// ==========================================
// STAFFING OVERVIEW TAB — Merged data
// ==========================================

// Needs Attention — auto-populated urgent items
export const mockNeedsAttention = {
  'unit-4w': [
    { id: 'attn-1', type: 'unassigned-role', roleName: 'Triage RN', department: 'Primary Care A', reason: 'Call-out', callOutTime: '5:42 AM', shift: 'Day (7a-7p)', credentialRequired: 'RN License', isCritical: true },
    { id: 'attn-2', type: 'expired-credential', staffName: 'Lisa Nguyen', department: 'Urgent Care', credentialType: 'RN License', daysOverdue: 16, role: 'RN' },
  ],
};

// 7-Day Coverage Calendar
// Generate 7 days starting from today with rotating mock coverage data
const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const coveragePatterns = [
  { scheduled: 16, required: 18, coverage: 89, gaps: 2, otFlag: false, status: 'watch',
    gapDetails: [
      { id: 'g-1', type: 'role', label: 'Triage RN — unassigned', department: 'Primary Care A', severity: 'critical' },
      { id: 'g-2', type: 'assignment', label: 'Rooming RN — pending acknowledgment', department: 'Primary Care A', severity: 'watch' },
    ] },
  { scheduled: 17, required: 18, coverage: 94, gaps: 1, otFlag: false, status: 'on-track',
    gapDetails: [
      { id: 'g-3', type: 'schedule', label: 'Floor RN — no shift scheduled', department: 'Primary Care B', severity: 'watch' },
    ] },
  { scheduled: 18, required: 18, coverage: 100, gaps: 0, otFlag: false, status: 'on-track', gapDetails: [] },
  { scheduled: 15, required: 18, coverage: 83, gaps: 3, otFlag: true, status: 'critical',
    gapDetails: [
      { id: 'g-4', type: 'role', label: 'Charge Nurse — unassigned', department: 'Primary Care A', severity: 'critical' },
      { id: 'g-5', type: 'role', label: 'Infusion RN — unassigned', department: 'Oncology', severity: 'critical' },
      { id: 'g-6', type: 'schedule', label: 'Float RN — no shift scheduled', department: 'Float Pool', severity: 'watch' },
    ] },
  { scheduled: 14, required: 18, coverage: 78, gaps: 4, otFlag: true, status: 'critical',
    gapDetails: [
      { id: 'g-7', type: 'role', label: 'Triage RN — unassigned', department: 'Primary Care A', severity: 'critical' },
      { id: 'g-8', type: 'role', label: 'Charge Nurse — unassigned', department: 'Primary Care B', severity: 'critical' },
      { id: 'g-9', type: 'assignment', label: 'Care Coordinator — pending acknowledgment', department: 'Oncology', severity: 'watch' },
      { id: 'g-10', type: 'schedule', label: 'Check-In — no shift scheduled', department: 'Admin / Front Desk', severity: 'watch' },
    ] },
  { scheduled: 10, required: 12, coverage: 83, gaps: 2, otFlag: false, status: 'watch',
    gapDetails: [
      { id: 'g-11', type: 'schedule', label: 'Floor RN — no shift scheduled', department: 'Urgent Care', severity: 'watch' },
      { id: 'g-12', type: 'role', label: 'Medical Assistant — unassigned', department: 'Urgent Care', severity: 'watch' },
    ] },
  { scheduled: 10, required: 12, coverage: 83, gaps: 2, otFlag: false, status: 'watch',
    gapDetails: [
      { id: 'g-13', type: 'assignment', label: 'Floor RN — pending acknowledgment', department: 'Primary Care A', severity: 'watch' },
      { id: 'g-14', type: 'schedule', label: 'Check-Out — no shift scheduled', department: 'Admin / Front Desk', severity: 'watch' },
    ] },
];

function buildCoverageWeek() {
  const startDate = new Date();
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(startDate);
    d.setDate(d.getDate() + i);
    const dateStr = d.toISOString().slice(0, 10);
    const pattern = coveragePatterns[i % coveragePatterns.length];
    return { ...pattern, date: dateStr, dayLabel: DAY_LABELS[d.getDay()] };
  });
}

export const mockCoverageCalendar = {
  'unit-4w': buildCoverageWeek(),
};

// Department Staffing — merged dept → roles + credentials + absence flags
export const mockDepartmentStaffing = {
  'unit-4w': [
    {
      id: 'dept-pca', name: 'Primary Care A',
      coverage: 72, required: 8, scheduled: 6, actual: 5, openShifts: 2, otHours: 18, status: 'critical',
      absenceFlag: 'Mon call-out rate +48% above avg',
      credentialAlerts: 1,
      roles: [
        { id: 'ra-001', roleName: 'Charge Nurse', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', assignedStaffName: 'Maria Lopez', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: { type: 'RN License', daysUntil: 15 } },
        { id: 'ra-002', roleName: 'Triage RN', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', assignedStaffName: null, acknowledgment: 'unassigned', callOut: true, callOutTime: '5:42 AM', staffCredentialWarning: null },
        { id: 'ra-003', roleName: 'Rooming RN', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: 'RN License', assignedStaffName: 'Sarah Kim', acknowledgment: 'pending', callOut: false, callOutTime: null, staffCredentialWarning: null },
        { id: 'ra-004', roleName: 'Medical Assistant', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, assignedStaffName: 'Emily Tran', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: { type: 'Fire Safety', daysUntil: 28 } },
      ],
      credentials: [
        { id: 'cred-001', staffName: 'Maria Lopez', type: 'RN License', state: 'NY', expirationDate: '2026-04-15', daysUntilExpiration: 15, status: 'expiring-soon' },
        { id: 'cred-002', staffName: 'Maria Lopez', type: 'BLS', state: null, expirationDate: '2027-06-01', daysUntilExpiration: 427, status: 'current' },
        { id: 'cred-011', staffName: 'Emily Tran', type: 'HIPAA Training', state: null, expirationDate: '2026-06-30', daysUntilExpiration: 91, status: 'current' },
        { id: 'cred-012', staffName: 'Emily Tran', type: 'Fire Safety', state: null, expirationDate: '2026-04-28', daysUntilExpiration: 28, status: 'expiring-soon' },
      ],
      availableStaff: [
        { id: 'staff-111', name: 'Karen Lee', role: 'RN', credentials: ['RN License'] },
        { id: 'staff-112', name: 'Tom Bradley', role: 'RN', credentials: ['RN License'] },
        { id: 'staff-103', name: 'Sarah Kim', role: 'RN', credentials: ['RN License'] },
      ],
    },
    {
      id: 'dept-pcb', name: 'Primary Care B',
      coverage: 85, required: 6, scheduled: 5, actual: 5, openShifts: 1, otHours: 8, status: 'watch',
      absenceFlag: null, credentialAlerts: 1,
      roles: [
        { id: 'ra-005', roleName: 'Charge Nurse', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', assignedStaffName: 'David Chen', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: { type: 'ACLS', daysUntil: 10 } },
        { id: 'ra-006', roleName: 'Floor RN', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: 'RN License', assignedStaffName: null, acknowledgment: 'unassigned', callOut: false, callOutTime: null, staffCredentialWarning: null },
      ],
      credentials: [
        { id: 'cred-005', staffName: 'David Chen', type: 'RN License', state: 'NY', expirationDate: '2026-05-20', daysUntilExpiration: 50, status: 'upcoming' },
        { id: 'cred-006', staffName: 'David Chen', type: 'ACLS', state: null, expirationDate: '2026-04-10', daysUntilExpiration: 10, status: 'expiring-soon' },
        { id: 'cred-015', staffName: 'Amanda Foster', type: 'RN License', state: 'NY', expirationDate: '2026-11-30', daysUntilExpiration: 244, status: 'current' },
      ],
      availableStaff: [
        { id: 'staff-106', name: 'Amanda Foster', role: 'RN', credentials: ['RN License'] },
        { id: 'staff-111', name: 'Karen Lee', role: 'RN', credentials: ['RN License'] },
      ],
    },
    {
      id: 'dept-onc', name: 'Oncology',
      coverage: 90, required: 5, scheduled: 5, actual: 4, openShifts: 0, otHours: 12, status: 'watch',
      absenceFlag: null, credentialAlerts: 0,
      roles: [
        { id: 'ra-008', roleName: 'Infusion RN', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License + OCN', assignedStaffName: 'Patricia Gomez', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: null },
        { id: 'ra-009', roleName: 'Care Coordinator', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, assignedStaffName: 'Kevin Wright', acknowledgment: 'pending', callOut: false, callOutTime: null, staffCredentialWarning: null },
      ],
      credentials: [
        { id: 'cred-007', staffName: 'Patricia Gomez', type: 'RN License', state: 'NY', expirationDate: '2027-01-15', daysUntilExpiration: 290, status: 'current' },
        { id: 'cred-008', staffName: 'Patricia Gomez', type: 'OCN', state: null, expirationDate: '2027-09-01', daysUntilExpiration: 519, status: 'current' },
      ],
      availableStaff: [],
    },
    {
      id: 'dept-uc', name: 'Urgent Care',
      coverage: 100, required: 4, scheduled: 4, actual: 4, openShifts: 0, otHours: 2, status: 'on-track',
      absenceFlag: null, credentialAlerts: 1,
      roles: [
        { id: 'ra-010', roleName: 'Triage RN', shift: 'Day (7a-7p)', isCritical: true, credentialRequired: 'RN License', assignedStaffName: 'Lisa Nguyen', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: { type: 'RN License', daysUntil: -16 } },
      ],
      credentials: [
        { id: 'cred-009', staffName: 'Lisa Nguyen', type: 'RN License', state: 'NY', expirationDate: '2026-03-15', daysUntilExpiration: -16, status: 'expired' },
        { id: 'cred-010', staffName: 'Lisa Nguyen', type: 'BLS', state: null, expirationDate: '2026-04-01', daysUntilExpiration: 1, status: 'expiring-soon' },
      ],
      availableStaff: [],
    },
    {
      id: 'dept-admin', name: 'Admin / Front Desk',
      coverage: 100, required: 3, scheduled: 3, actual: 3, openShifts: 0, otHours: 2, status: 'on-track',
      absenceFlag: null, credentialAlerts: 0,
      roles: [
        { id: 'ra-007', roleName: 'Check-In', shift: 'Day (7a-7p)', isCritical: false, credentialRequired: null, assignedStaffName: 'Rosa Martinez', acknowledgment: 'confirmed', callOut: false, callOutTime: null, staffCredentialWarning: null },
      ],
      credentials: [
        { id: 'cred-016', staffName: 'Rosa Martinez', type: 'HIPAA Training', state: null, expirationDate: '2026-09-15', daysUntilExpiration: 168, status: 'current' },
      ],
      availableStaff: [],
    },
  ],
};

// Staffing Intelligence — compact insight data for bottom grid
export const mockStaffingIntelligence = {
  'unit-4w': {
    absencePatterns: {
      overallRate: 6.2, rolling30d: 5.8, threshold: 8.0,
      topFlag: 'Monday call-out rate +48% above average',
      trend: [5.8, 5.5, 6.2, 5.9, 6.1, 6.5, 5.8, 6.3, 6.8, 6.2, 5.8, 6.2],
    },
    otTrends: {
      currentHours: 42, budgetThreshold: 40, topDept: 'Primary Care A', topDeptPct: 43,
      trend: [38, 35, 40, 42, 39, 44, 38, 41, 45, 42, 40, 42],
    },
    credentialCompliance: {
      expired: 2, expiring30d: 5, complianceRate: 83,
      trend: [88, 87, 85, 86, 84, 83, 85, 84, 82, 83, 84, 83],
    },
    patternFlags: [
      { id: 'pf-1', text: 'Monday call-out rate +48% above avg', dept: 'Primary Care A', severity: 'critical' },
      { id: 'pf-2', text: 'RN absence rate trending up 3 consecutive weeks', dept: 'All', severity: 'watch' },
      { id: 'pf-3', text: 'Friday call-out rate +26% above avg', dept: 'All', severity: 'watch' },
    ],
  },
};
